import { render } from "./CheckboxesMultyPicker.vue?vue&type=template&id=0145c7cd&scoped=true"
import script from "./CheckboxesMultyPicker.vue?vue&type=script&lang=js"
export * from "./CheckboxesMultyPicker.vue?vue&type=script&lang=js"

import "./CheckboxesMultyPicker.vue?vue&type=style&index=0&id=0145c7cd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0145c7cd"]])

export default __exports__